import { render, staticRenderFns } from "./systemVer.vue?vue&type=template&id=5aada63a&scoped=true&"
import script from "./systemVer.vue?vue&type=script&lang=js&"
export * from "./systemVer.vue?vue&type=script&lang=js&"
import style0 from "./systemVer.vue?vue&type=style&index=0&id=5aada63a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aada63a",
  null
  
)

export default component.exports